<template>
  <div class="login">
    <div>
      <van-image
        style="margin-top: 46px"
        width="346"
        height="157"
        :src="require('@/assets/logo.png')"
      />

      <!-- <div>
        <p class="app-title">Welcome to</p>
        <p class="app-title">Macau Grand Lisboa Casino</p>
      </div> -->

      <div>
        <van-form>
          <van-field
            v-model="username"
            name=""
            label=""
            placeholder="Enter the account number"
            style="
              width: 80%;
              margin: 0 auto;
              border: 1px solid #eee;
              border-radius: 10px;
              margin-bottom: 10px;
              background-color: transparent;
            "
            class="text-color"
            :rules="[{ required: true, message: 'Please enter user name' }]"
          />
          <van-field
            v-model="password"
            type="password"
            name=""
            label=""
            placeholder="Enter password"
            style="
              width: 80%;
              margin: 0 auto;
              border: 1px solid #eee;
              border-radius: 10px;
              background-color: transparent;
            "
            class="text-color"
            :rules="[{ required: true, message: 'Please enter the pawword' }]"
          />
          <div style="margin: 16px">
            <van-button
              class="button-background"
              style="width: 80%; margin: 0 auto"
              round
              block
              type="info"
              native-type=""
              @click="login"
              >{{ $t("button.login") }}</van-button
            >
          </div>
        </van-form>

        <div style="margin: 16px">
          <van-button
            style="
              width: 80%;
              margin: 0 auto;
              border: 1px solid #eee;
              background-color: transparent;
              color: #fff;
            "
            round
            block
            plain
            type=""
            native-type=""
            @click="navTo('register')"
            >{{ $t("button.register") }}</van-button
          >
        </div>
      </div>

      <div ref="container" class="tel-contact">
        <van-sticky :container="container">
          <a :href="config.telegraph" target="_blank">
            <div>
              <van-icon name="service-o" size="3rem" color="#000" />
            </div>
          </a>
          <!-- <van-icon name="chat" size="3rem" color="#1990cb" /> -->
        </van-sticky>
      </div>
    </div>
  </div>
</template>

<script>
import { login, getConfigInfo } from "@/common/api/api";

export default {
  name: "login",
  data() {
    return {
      username: "",
      password: "",
      status: "login",
      container: null,
      config: {},
    };
  },
  created() {
    this.getConfig();
  },
  mounted() {
    this.container = this.$refs.container;
  },
  methods: {
    login() {
      if (
        /[a-zA-Z0-9]{6,}/.test(this.username) &&
        /[a-zA-Z0-9]{6,}/.test(this.password)
      ) {
        login(this.username.trim(), this.password.trim(), this.status).then(
          (res) => {
            if (res.code == 20010) {
              this.$toast.fail({
                duration: 5000,
                message:
                  "Your account is abnormal, please contact customer service",
              });
            } else if (res.code == 20011) {
              this.$toast.fail({
                duration: 5000,
                message: "Your account password is wrong",
              });
            } else {
              localStorage.setItem(res.data.tokenName, res.data.tokenValue);
              this.$router.push("/");
            }
          }
        );
      } else {
        this.$toast.fail("Please enter the appropriate account and password");
      }
    },
    navTo(path) {
      this.$router.push(path);
    },
    getConfig() {
      getConfigInfo().then((res) => {
        this.config = res.data;
      });
    },
  },
};
</script>

<style lang="scss">
.login {
  width: 100%;
  height: 100vh;
  background: linear-gradient(
      to bottom right,
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 0.8)
    ),
    url("@/assets/login-background.jpg") center center no-repeat;
  background-size: cover;
}

.app-title {
  /* color: #1c1c36; */
  color: #fff;
  font-size: 22px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
}

.button-background {
  background-image: linear-gradient(90deg, #d4b38f 0%, #b88964 100%) !important;
  border: 1px solid #eee;
}
.text-color {
  .van-field__control {
    color: #fff;
  }
}

.tel-contact {
  position: absolute;
  bottom: 3rem;
  right: 2rem;
  // background: #ff9900;
  background: #b88964;
  border-radius: 100%;
}
</style>
